import { connect } from 'react-redux';
import Subscription from '../Component/Subscription';
import * as actions from "../../../Actions";

const mapStateToProps = (state) => {
  return {
    PriceList: state.priceList,
    inProgress: state.orderSubmit.inProgress,
  }
}

const mapDispatchToProps  = {
  getPriceList: actions.getPriceList,
  updateCustomerLastCompletedStep: actions.updateCustomerLastCompletedStep
}

export default (connect(mapStateToProps, mapDispatchToProps)(Subscription));